import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Layout from "./components/Layout/Layout";
import Landing from "./components/Product/Landing/Landing";
import CategoryProducts from "./components/Product/CategoryProducts";

import OTPLogin from "./components/Auth/OTPLogin";
import CartPage from "./components/Cart/CartPage";
import { CartProvider } from "./components/Cart/CartContext";
import ProductDetail from "./components/Product/Detail/ProductDetail";
import CheckoutPage from "./components/Checkout/CheckoutPage";
import InvoicesPage from "./components/Checkout/InvoicesPage";
import PaymentList from "./components/Payment/PaymentList";
import Wishlist from "./components/Wishlist/Wishlist";
import NotFoundPage from "./components/404/NotFoundPage";
import { AuthProvider } from "./services/auth";
import { ProtectedRoute, PublicRoute } from "./services/auth/RouteGuards";

import UserQuickNav from "../src/components/Layout/UserQuickNav";
import FAQAccordion from "../src/components/Layout/FAQ";
import UserProfile from "./components/Auth/UserProfile";
import ProductXlsUpload from "./components/Product/ProductXlsUpload";
import { AdminRoute } from "./services/auth/RouteGuards";
import BulkPurchaseInfo from "./components/Layout/BulkPurchaseInfo";
import InventoryCheck from "./components/Checkout/InventoryCheck";

export default function App() {
  return (
    <Router
          future={{
            v7_relativeSplatPath: true,
            v7_startTransition: true,
          }}
        >
          <AuthProvider>
            <CartProvider>
              <Routes>
                <Route
                  path="/login"
                  element={
                    <PublicRoute>
                      <OTPLogin />
                    </PublicRoute>
                  }
                />

                <Route element={<Layout />}>
                  <Route index element={<Landing />} />
                  {/* Landing  */}
                  <Route path="/" element={<Landing />} />
                  {/* Category Slug  */}
                  <Route
                    path="/category/:slug"
                    element={<CategoryProducts />}
                  />
                  {/* Product Info  */}
                  <Route
                    path="/product/:productSlug"
                    element={<ProductDetail />}
                  />

                  {/* Buy Info  */}
                  <Route path="/condition" element={<BulkPurchaseInfo />} />
                  {/* FAQ  */}
                  <Route path="/faq" element={<FAQAccordion />} />

                 

                 
                  
                  <Route
                    path="/invoices"
                    element={
                      <ProtectedRoute>
                        <InvoicesPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/payments/list"
                    element={
                      <ProtectedRoute>
                        <PaymentList />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/wishlist"
                    element={
                      <ProtectedRoute>
                        <Wishlist />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/profile"
                    element={
                      <ProtectedRoute>
                        <UserQuickNav />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/userProfile"
                    element={
                      <ProtectedRoute>
                        <UserProfile />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/inventory-check-requests"
                    element={
                      <ProtectedRoute>
                        <InventoryCheck />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/upload"
                    element={
                      <AdminRoute>
                        <ProductXlsUpload />
                      </AdminRoute>
                    }
                  />

                  <Route path="*" element={<NotFoundPage />} />
                </Route>

                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </CartProvider>
          </AuthProvider>
        </Router>
      );
    }
